<div class="se-fe-footer">
  <div class="se-fe-footer__container">
    <ng-content></ng-content>
  </div>
</div>
